export default import.meta.ROLLDOWN_FILE_URL_xk3_6X23tKf_Scjj9W5unA